import { render, staticRenderFns } from "./DetailsHead.vue?vue&type=template&id=46596e3f&scoped=true"
import script from "./DetailsHead.vue?vue&type=script&lang=js"
export * from "./DetailsHead.vue?vue&type=script&lang=js"
import style0 from "./DetailsHead.vue?vue&type=style&index=0&id=46596e3f&prod&scoped=true&lang=css"
import style1 from "./DetailsHead.vue?vue&type=style&index=1&id=46596e3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46596e3f",
  null
  
)

export default component.exports